/**
 * The Physical AI highlight loops — short, muted moments cut from the owner's
 * robot videos by `scripts/build-videos.py` (which records why each moment was
 * chosen). Captions follow docs/DESIGN.md, Claims:
 * - the teach-and-repeat arm replays a recorded move; it is never called AI;
 * - the learned arm is a demo of a policy trained from human demonstrations,
 *   not a reliability claim;
 * - the hand is an open hardware design; what we show is the control.
 */
export interface Clip {
  id: string;
  src: string;
  poster: string;
  title: string;
  line: string;
}

export const CLIP_SIZE = { width: 960, height: 540 } as const;

export const CLIPS: readonly Clip[] = [
  {
    id: 'hand-mirror',
    src: '/video/hand-mirror.mp4',
    poster: '/video/hand-mirror.webp',
    title: 'Camera hand-tracking',
    line: 'A robot hand mirrors a human hand, live, from a camera.',
  },
  {
    id: 'arm-ai',
    src: '/video/arm-ai.mp4',
    poster: '/video/arm-ai.webp',
    title: 'Learned from demonstration',
    line: 'An arm trained on a few human demos reaches for the target on its own.',
  },
  {
    id: 'arm-teach',
    src: '/video/arm-teach.mp4',
    poster: '/video/arm-teach.webp',
    title: 'Teach and repeat',
    line: 'A taught move, replayed exactly: grip, lift, place.',
  },
];
